import { isIe } from '../utils/is-ms';
import { $body } from '../utils/globals';

if (isIe()) {
  $('.js-image-fit').each((i, container) => {
    const $container = $(container);
    const $image = $container.find('img');
    const imageSource = $image.attr('src') || $image.data('src');

    $container.css('background-image', `url(${imageSource})`);
    $image.addClass('sr-only');
  });
}

var ua = window.navigator.userAgent;
var msie = ua.indexOf('MSIE ');

if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
  $body.addClass('is-ie');
}
